import * as req from 'api/actions';
import * as c from './constant';

export const getRequirementList = (payload, callback) => req.list(
  c.GET_REQUIREMENT_LIST,
  '/api/v1/administrators/requirements/',
  payload,
  callback,
);

export const fetchRequirementsList = (payload, callback) => req.list(
  c.FETCH_REQUIREMENTS_LIST,
  `/api/v1/ebpls/administrator/ebpls_requirements`,
  payload,
  callback,
);

export const updateApplicationRequirements = (payload, callback) => req.update(
  c.UPDATE_APPLICATION_REQUIREMENT,
  '/api/v1/ebpls/administrator/ebpls_requirements/set',
  payload,
  callback,
);

export const getSettingsList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_SETTINGS, 
    '/api/v1/administrators/module_systems/EBPLS/application_statuses', 
    payload, 
    callback
  );